import { useThemeMode } from "../lib/theme";

export function ControlThemeSelect() {
  const { mode, setMode } = useThemeMode();
  return (
    <label className="flex items-center gap-2 text-xs text-muted-foreground">
      <span className="hidden md:inline">Izgled</span>
      <select aria-label="Izgled Control Centra" value={mode}
        onChange={(event) => setMode(event.target.value)}
        className="w-20 rounded border border-border bg-background px-2 py-1.5 text-xs text-foreground md:w-auto md:px-3 md:py-2 md:text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
        <option value="light">Svijetli</option>
        <option value="dark">Tamni</option>
        <option value="system">Sustav</option>
      </select>
    </label>
  );
}
